/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../widgets/livewidget/nls/StringResources'
], function(stringResources) {

	return [{
		'value': 'Anton',
		'label': 'Anton',
		'cssClass': 'rt_fontFamilyAnton'
	}, {
		'value': 'CherryCreamSoda',
		'label': 'Cherry Cream Soda',
		'cssClass': 'rt_fontFamilyCherryCreamSoda'
	}, {
		'value': 'Condiment-Regular',
		'label': 'Condiment',
		'cssClass': 'rt_fontFamilyCondiment-Regular'
	}, {
		'value': 'DidactGothic',
		'label': 'Didact Gothic',
		'cssClass': 'rt_fontFamilyDidactGothic'
	}, {
		'value': 'EuphoriaScript-Regular',
		'label': 'Euphoria Script',
		'cssClass': 'rt_fontFamilyEuphoriaScript-Regular'
	}, {
		'value': 'Helvetica Neue for IBM',
		'label': 'Helvetica Neue',
		'cssClass': 'rt_fontFamilyHelvNeueforIBM-Regular',
		'subCssClasses': [{
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Light'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-LightItalic'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Regular'
		}, {
			'value': 'italic',
			'label': stringResources.get('textFontFamilySubClassItalic'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Italic'
		}, {
			'value': 'medium',
			'label': stringResources.get('textFontFamilySubClassMedium'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Medium'
		}, {
			'value': 'mediumitalic',
			'label': stringResources.get('textFontFamilySubClassMediumItalic'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-MediumItalic'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Bold'
		}, {
			'value': 'bolditalic',
			'label': stringResources.get('textFontFamilySubClassBoldItalic'),
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-BoldItalic'
		}]
	}, {
		'value': 'KaushanScript-Regular',
		'label': 'Kaushan Script',
		'cssClass': 'rt_fontFamilyKaushanScript-Regular'
	}, {
		'value': 'Lobster',
		'label': 'Lobster',
		'cssClass': 'rt_fontFamilyLobster'
	}, {
		'value': 'Merriweather-Regular',
		'label': 'Merriweather',
		'cssClass': 'rt_fontFamilyMerriweather-Regular',
		'subCssClasses': [{
			'value': 'italic',
			'label': stringResources.get('textFontFamilySubClassItalic'),
			'cssClass': 'rt_fontFamilyMerriweather-Italic'
		}, {
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyMerriweather-Light'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyMerriweather-Regular'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyMerriweather-Bold'
		}, {
			'value': 'bolditalic',
			'label': stringResources.get('textFontFamilySubClassBoldItalic'),
			'cssClass': 'rt_fontFamilyMerriweather-BoldItalic'
		}, {
			'value': 'black',
			'label': stringResources.get('textFontFamilySubClassBlack'),
			'cssClass': 'rt_fontFamilyMerriweather-Black'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyMerriweather-LightItalic'
		}, {
			'value': 'heavyitalic',
			'label': stringResources.get('textFontFamilySubClassHeavyItalic'),
			'cssClass': 'rt_fontFamilyMerriweather-HeavyItalic'
		}]
	}, {
		'value': 'MerriweatherSans-Regular',
		'label': 'Merriweather Sans',
		'cssClass': 'rt_fontFamilyMerriweatherSans-Regular',
		'subCssClasses': [{
			'value': 'italic',
			'label': stringResources.get('textFontFamilySubClassItalic'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-Italic'
		}, {
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-Light'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-LightItalic'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-Regular'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-Bold'
		}, {
			'value': 'bolditalic',
			'label': stringResources.get('textFontFamilySubClassBoldItalic'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-BoldItalic'
		}, {
			'value': 'extrabold',
			'label': stringResources.get('textFontFamilySubClassExtraBold'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-ExtraBold'
		}, {
			'value': 'extrabolditalic',
			'label': stringResources.get('textFontFamilySubClassExtraBoldItalic'),
			'cssClass': 'rt_fontFamilyMerriweatherSans-ExtraBoldItalic'
		}]
	}, {
		'value': 'Monoton-Regular',
		'label': 'Monoton',
		'cssClass': 'rt_fontFamilyMonoton-Regular'
	}, {
		'value': 'Montserrat-Regular',
		'label': 'Montserrat',
		'cssClass': 'rt_fontFamilyMontserrat-Regular',
		'subCssClasses': [{
			'value': 'hairline',
			'label': stringResources.get('textFontFamilySubClassHairline'),
			'cssClass': 'rt_fontFamilyMontserrat-Hairline'
		}, {
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyMontserrat-Light'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyMontserrat-Regular'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyMontserrat-Bold'
		}, {
			'value': 'black',
			'label': stringResources.get('textFontFamilySubClassBlack'),
			'cssClass': 'rt_fontFamilyMontserrat-Black'
		}]
	}, {
		'value': 'OpenSansCondensed-Light',
		'label': 'Open Sans Condensed',
		'cssClass': 'rt_fontFamilyOpenSansCondensed-Light',
		'subCssClasses': [{
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyOpenSansCondensed-Light'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyOpenSansCondensed-LightItalic'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyOpenSansCondensed-Bold'
		}]
	}, {
		'value': 'Oswald-Regular',
		'label': 'Oswald',
		'cssClass': 'rt_fontFamilyOswald-Regular',
		'subCssClasses': [{
			'value': 'extralight',
			'label': stringResources.get('textFontFamilySubClassExtraLight'),
			'cssClass': 'rt_fontFamilyOswald-ExtraLight'
		}, {
			'value': 'extralightitalic',
			'label': stringResources.get('textFontFamilySubClassExtraLightItalic'),
			'cssClass': 'rt_fontFamilyOswald-ExtraLightItalic'
		}, {
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyOswald-Light'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyOswald-LightItalic'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyOswald-Regular'
		}, {
			'value': 'regularitalic',
			'label': stringResources.get('textFontFamilySubClassRegularItalic'),
			'cssClass': 'rt_fontFamilyOswald-RegularItalic'
		}, {
			'value': 'medium',
			'label': stringResources.get('textFontFamilySubClassMedium'),
			'cssClass': 'rt_fontFamilyOswald-Medium'
		}, {
			'value': 'mediumitalic',
			'label': stringResources.get('textFontFamilySubClassMediumItalic'),
			'cssClass': 'rt_fontFamilyOswald-MediumItalic'
		}, {
			'value': 'demibold',
			'label': stringResources.get('textFontFamilySubClassDemiBold'),
			'cssClass': 'rt_fontFamilyOswald-DemiBold'
		}, {
			'value': 'demibolditalic',
			'label': stringResources.get('textFontFamilySubClassDemiBoldItalic'),
			'cssClass': 'rt_fontFamilyOswald-DemiBoldItalic'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyOswald-Bold'
		}, {
			'value': 'bolditalic',
			'label': stringResources.get('textFontFamilySubClassBoldItalic'),
			'cssClass': 'rt_fontFamilyOswald-BoldItalic'
		}, {
			'value': 'heavy',
			'label': stringResources.get('textFontFamilySubClassHeavy'),
			'cssClass': 'rt_fontFamilyOswald-Heavy'
		}, {
			'value': 'heavyitalic',
			'label': stringResources.get('textFontFamilySubClassHeavyItalic'),
			'cssClass': 'rt_fontFamilyOswald-HeavyItalic'
		}, {
			'value': 'stencil',
			'label': stringResources.get('textFontFamilySubClassStencil'),
			'cssClass': 'rt_fontFamilyOswald-Stencil'
		}]
	}, {
		'value': 'Playball',
		'label': 'Playball',
		'cssClass': 'rt_fontFamilyPlayball'
	}, {
		'value': 'IBM Plex Sans,Helvetica Neue,Arial,sans-serif',
		'label': 'IBM Plex Sans',
		'cssClass': ''
	}, {
		'value': 'IBM Plex Sans Condensed,Helvetica Neue,Arial,sans-serif',
		'label': 'IBM Plex Sans Condensed',
		'cssClass': ''
	}, {
		'value': 'Plex-Regular',
		'label': 'IBM Plex',
		'cssClass': 'rt_fontFamilyPlex-Regular',
		'subCssClasses': [{
			'value': 'thin',
			'label': stringResources.get('textFontFamilySubClassThin'),
			'cssClass': 'rt_fontFamilyPlex-Thin'
		}, {
			'value': 'thinitalic',
			'label': stringResources.get('textFontFamilySubClassThinItalic'),
			'cssClass': 'rt_fontFamilyPlex-ThinItalic'
		}, {
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyPlex-Light'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyPlex-LightItalic'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyPlex-Regular'
		}, {
			'value': 'italic',
			'label': stringResources.get('textFontFamilySubClassItalic'),
			'cssClass': 'rt_fontFamilyPlex-Italic'
		}, {
			'value': 'medium',
			'label': stringResources.get('textFontFamilySubClassMedium'),
			'cssClass': 'rt_fontFamilyPlex-Medium'
		}, {
			'value': 'mediumitalic',
			'label': stringResources.get('textFontFamilySubClassMediumItalic'),
			'cssClass': 'rt_fontFamilyPlex-MediumItalic'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyPlex-Bold'
		}, {
			'value': 'bolditalic',
			'label': stringResources.get('textFontFamilySubClassBoldItalic'),
			'cssClass': 'rt_fontFamilyPlex-BoldItalic'
		}]
	}, {
		'value': 'Roboto-Regular',
		'label': 'Roboto',
		'cssClass': 'rt_fontFamilyRoboto-Regular',
		'subCssClasses': [{
			'value': 'thin',
			'label': stringResources.get('textFontFamilySubClassThin'),
			'cssClass': 'rt_fontFamilyRoboto-Thin'
		}, {
			'value': 'thinitalic',
			'label': stringResources.get('textFontFamilySubClassThinItalic'),
			'cssClass': 'rt_fontFamilyRoboto-ThinItalic'
		}, {
			'value': 'light',
			'label': stringResources.get('textFontFamilySubClassLight'),
			'cssClass': 'rt_fontFamilyRoboto-Light'
		}, {
			'value': 'lightitalic',
			'label': stringResources.get('textFontFamilySubClassLightItalic'),
			'cssClass': 'rt_fontFamilyRoboto-LightItalic'
		}, {
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilyRoboto-Regular'
		}, {
			'value': 'italic',
			'label': stringResources.get('textFontFamilySubClassItalic'),
			'cssClass': 'rt_fontFamilyRoboto-Italic'
		}, {
			'value': 'medium',
			'label': stringResources.get('textFontFamilySubClassMedium'),
			'cssClass': 'rt_fontFamilyRoboto-Medium'
		}, {
			'value': 'mediumitalic',
			'label': stringResources.get('textFontFamilySubClassMediumItalic'),
			'cssClass': 'rt_fontFamilyRoboto-MediumItalic'
		}, {
			'value': 'bold',
			'label': stringResources.get('textFontFamilySubClassBold'),
			'cssClass': 'rt_fontFamilyRoboto-Bold'
		}, {
			'value': 'bolditalic',
			'label': stringResources.get('textFontFamilySubClassBoldItalic'),
			'cssClass': 'rt_fontFamilyRoboto-BoldItalic'
		}, {
			'value': 'black',
			'label': stringResources.get('textFontFamilySubClassBlack'),
			'cssClass': 'rt_fontFamilyRoboto-Black'
		}, {
			'value': 'blackitalic',
			'label': stringResources.get('textFontFamilySubClassBlackItalic'),
			'cssClass': 'rt_fontFamilyRoboto-BlackItalic'
		}]
	}, {
		'value': 'SortsMillGoudy-Regular',
		'label': 'Sorts Mill Goudy',
		'cssClass': 'rt_fontFamilySortsMillGoudy-Regular',
		'subCssClasses': [{
			'value': 'regular',
			'label': stringResources.get('textFontFamilySubClassRegular'),
			'cssClass': 'rt_fontFamilySortsMillGoudy-Regular'
		}, {
			'value': 'italic',
			'label': stringResources.get('textFontFamilySubClassItalic'),
			'cssClass': 'rt_fontFamilySortsMillGoudy-Italic'
		}]
	}, {
		'value': 'SpecialElite',
		'label': 'Special Elite',
		'cssClass': 'rt_fontFamilySpecialElite'
	}];

});
